var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[(_vm.$store.getters.isAuthenticated)?_c('el-aside',{attrs:{"width":"250px"}},[_c('Menu')],1):_vm._e(),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }